import { isExpired } from "react-jwt";
import { Auth } from "aws-amplify";
import { logout } from "./api/api";
import { useLocation, useNavigate } from "react-router-dom";

const AuthVerify = () => {
    const valueCheck = ["", undefined, null, false, "[]", "{}"];
    const { pathname } = useLocation();
    var navigator = useNavigate();
    const isTokenCheckingPage = ["/fcc_login", '/dwp_login', '/pb_login', '/contact_create', '/contact_confirm', '/contact_complete'].includes(pathname) ? false : true;
    if(!isTokenCheckingPage){
        return;
    }
    const checkToken = async () => {
        try{
            const token = (await Auth.currentSession()).getIdToken().getJwtToken();
            if (valueCheck.includes(token) === false) {
                if (isExpired(token)) {
                    logout();
                    navigator("/fcc_login");
                    return;
                }
            } else {
                logout();
                return window.location.replace('/fcc_login');
            }
        }catch(e){
            logout();
            return window.location.replace('/fcc_login');
        }
    };
    checkToken();

    // return;
};

export default AuthVerify;